import React, { useEffect, useState } from 'react'
import Features from "../features/features";
import IntroVideo from "../introVideo/introVideo";
import LandingPageNew from "../landingPageNew/landingPageNew";
import { useLocation } from 'react-router-dom';
const Home = () => {
    const { pathname } = useLocation();
    const location = useLocation();

    useEffect(() => {
        // Scroll to the target section when the page loads
        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth" });
                }, 0); // Use a delay to ensure the element is rendered before scrolling
            }
        }
    }, [location]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <div>
            <LandingPageNew />
            <IntroVideo />
            <Features />
        </div>
    )
}

export default Home